import React, { useState } from "react";
import {
  ProSidebar,
  Menu,
  MenuItem,
  SidebarFooter,
  SidebarContent,
  SidebarHeader,
} from "react-pro-sidebar";
import "react-pro-sidebar/dist/css/styles.css";
import { TiExport } from "react-icons/ti";
import {
  AiFillCaretRight,
  AiFillCaretLeft,
  AiFillDelete,
} from "react-icons/ai";
import { BiHide, BiShow } from "react-icons/bi";
import { FcCommandLine } from "react-icons/fc";

export default function SideBar({
  onClear,
  onToggleEditor,
  showEditor,
  onExport,
}) {
  const [collapsed, setCollapsed] = useState(true);
  return (
    <ProSidebar collapsed={collapsed} style={{ height: "auto" }}>
      <SidebarHeader>
        <Menu>
          <MenuItem icon={<FcCommandLine size={30} />}>
            <b>CodePlay</b>
          </MenuItem>
        </Menu>
      </SidebarHeader>
      <SidebarContent>
        <Menu iconShape="circle">
          <MenuItem
            icon={showEditor ? <BiHide size={20} /> : <BiShow size={20} />}
            onClick={() => {
              onToggleEditor();
              setCollapsed(true);
            }}
          >
            {(showEditor ? "Hide" : "Show") + " Editor"}
          </MenuItem>
          <MenuItem
            icon={<TiExport size={20} />}
            onClick={() => {
              onExport();
              setCollapsed(true);
            }}
          >
            Export
          </MenuItem>
          <MenuItem
            icon={<AiFillDelete size={20} />}
            onClick={() => {
              if (window.confirm("The data you have entered will be lost"))
                onClear();
              setCollapsed(true);
            }}
          >
            Clear
          </MenuItem>
        </Menu>
      </SidebarContent>
      <SidebarFooter>
        <Menu>
          <MenuItem
            icon={
              collapsed ? (
                <AiFillCaretRight size={20} />
              ) : (
                <AiFillCaretLeft size={20} />
              )
            }
            onClick={() => setCollapsed(!collapsed)}
          >
            Collapse
          </MenuItem>
        </Menu>
      </SidebarFooter>
    </ProSidebar>
  );
}
